import { cn } from '@cocoonspace/ui/lib/utils'

import { MainContainer } from './atoms/main-container'

export const ContentContainer = ({
	children,
	className,
}: {
	children: React.ReactNode
	className?: string
}) => (
	<MainContainer
		className={cn(
			'prose prose-slate',
			'[&_b]:!font-bold',
			'prose-ul:my-0',

			// Headings
			'prose-headings:my-4',
			'prose-h1:font-bold prose-h1:text-5xl',
			'prose-h2:font-bold prose-h2:text-4xl',
			'prose-h3:font-bold prose-h3:text-3xl',
			'max-w-[800px] gap-4 leading-snug [&>p]:m-0',
			'prose-p:pb-4 [&_.notion-text]:pb-4',

			// Imgs
			'[&_img]:mx-auto [&_img]:max-w-md [&_img]:rounded-lg',

			// Callouts
			'[&_.notion-callout]:bg-card [&_.notion-callout]:rounded-lg [&_.notion-callout]:border-none [&_.notion-callout]:shadow-xs',

			// Hash links
			'[&_.notion-hash-link]:relative [&_.notion-hash-link_svg]:absolute [&_.notion-hash-link_svg]:top-1/2 [&_.notion-hash-link_svg]:-left-6 [&_.notion-hash-link_svg]:-translate-y-1/2 [&_.notion-hash-link_svg]:opacity-20',
			className,
		)}
	>
		{children}
	</MainContainer>
)
